import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerlessProvider } from './serverless';
import { SystemDashboardVehiclesApiRequest } from './models/system-dashboard-vehicles-api-request';
import { SystemDashboardVehiclesApiResponse } from './models/system-dashboard-vehicles-api-response';
import { SystemDashboardVehicle } from "./models/system-dashboard-vehicle";
import { GenericItem } from './models/generic-item';

/**
 * [システム][ダッシュボード]車両一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardVehiclesServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardVehicles';

  constructor(public serverless: ServerlessProvider) { }

  /**
   * 車両一覧を取得する.
   * 
   * @param vehicleIds 車両IDの一覧
   * @returns 車両一覧, 画像URLプレフィックス
   */
  public get(vehicleIds: number[]): Observable<[SystemDashboardVehicle[], string]> {
    const requestBody: SystemDashboardVehiclesApiRequest = { vehicleIds: vehicleIds };
    return this.serverless.postApi<SystemDashboardVehiclesApiRequest, GenericItem<SystemDashboardVehiclesApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   * 
   * @param responseBody レスポンスボディ
   * @returns 車両一覧, 画像URLプレフィックス
   */
  private toModel(responseBody: GenericItem<SystemDashboardVehiclesApiResponse>): [SystemDashboardVehicle[], string] {
    return [
      responseBody.item.vehicles,
      responseBody.item.imgUrlPrefix
    ];
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-vehicles-service.ts